import type { ThreeAssetLoaderContext } from "./THREEAssetLoaderTypes";
import { DRACOLoader } from "./threejs/examples/jsm/loaders/DRACOLoader";

// Re-export from shared module for backwards compatibility
export { ImageFormatFeature, browserCheckImageFormatSupport } from "./imageFormatSupport";

/**
 * Creates the browser loader context configuration.
 * Returns the context instead of setting it directly to avoid circular dependency.
 */
export function createBrowserLoaderContext(): ThreeAssetLoaderContext {
  const dracoLoader = new DRACOLoader(undefined);
  dracoLoader.setDecoderPath("/static/draco156/");
  return { dracoLoader };
}
